export default __webpack_public_path__ + "static/media/basic_hrv.f8b88e95.png";